import { yup } from '@guiker/yup-util'

import { listingOperatorSchema as baseListingOperatorSchema } from '../../schemas'

export const listingOperatorSchema = baseListingOperatorSchema.shape({
  isLeaseContractSigner: yup.boolean().required(),
  isContactPerson: yup.boolean().required(),
})
